let baseInfo = [
    {
        path: '/baseInfo/home',
        name: 'home',
        component: () => import('@/views/baseInfo/home.vue'),
        meta: {keepAlive: true, parentPath: 'baseInfo'},
    },
    {
        path: '/baseInfo/sysMenu',
        name: 'sysMenu',
        component: () => import('@/views/baseInfo/sysMenu.vue'),
        meta: {keepAlive: true, parentPath: 'baseInfo'},
    },
    {
        path: '/baseInfo/sysRoles',
        name: 'sysRoles',
        component: () => import('@/views/baseInfo/sysRoles/sysRoles.vue'),
        meta: {keepAlive: true, parentPath: 'baseInfo'},
    },
    {
        path: '/baseInfo/sysRoles/edit',
        name: 'sysRolesEdit',
        component: () => import('@/views/baseInfo/sysRoles/edit.vue'),
        meta: {keepAlive: true, parentPath: 'baseInfo'},
    },
    {
        path: '/baseInfo/sysAdmin',
        name: 'sysAdmin',
        component: () => import('@/views/baseInfo/sysAdmin.vue'),
        meta: {keepAlive: true, parentPath: 'baseInfo'},
    },
    {
        path: '/baseInfo/sysMaterial',
        name: 'sysMaterial',
        component: () => import('@/views/baseInfo/sysMaterial.vue'),
        meta: {keepAlive: true, parentPath: 'baseInfo'},
    },
    {
        path: '/baseInfo/component',
        name: 'component',
        component: () => import('@/views/component.vue'),
        meta: {keepAlive: true, parentPath: 'baseInfo'},
    }
    
]
export default baseInfo


// WEBPACK FOOTER //
// ./src/router/baseInfo.js